<template>
    <vx-card title="Simple Stock Transfer Order">
        <div class="vx-input-group flex">
            <vs-tabs>
                <vs-tab label="Open">
                    <tab-open></tab-open>
                </vs-tab>
                <vs-tab label="Received">
                    <tab-received></tab-received>
                </vs-tab>
            </vs-tabs>
        </div>
    </vx-card>
</template>
<script>
import TabOpen from "./TabOpen.vue";
import TabReceived from "./TabReceived.vue";
export default {
    components: {
        TabOpen,
        TabReceived,
    },
    data() {
        return {
            activeTab: "Open",
        }
    },
    methods: {

    }
}
</script>